import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Skeleton } from '@src/shared/ui/components/Widget/components/Skeleton';
import { isEmpty } from 'lodash';
import React from 'react';

import { HorizontalBarChart } from './components/HorizontalBarChart';

/**
 * Widget: TrustedRecordsCount
 *
 * @TODO Needs description.
 *
 * @param data
 * @returns {Element}
 * @constructor
 */
export function TrustedRecordsCount({ data = {} }) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/TrustedRecordsCount/TrustedRecordsCount.jsx">
      {isEmpty(data) ? (
        <Skeleton />
      ) : (
        <Widget description={data?.description || ''} title={data?.name || 'Trusted Records Count'}>
          {data?.defaultView === 'horizontalBarChart' && <HorizontalBarChart data={data?.data?.content} />}
        </Widget>
      )}
    </ErrorHandler>
  );
}
